module.exports = __webpack_public_path__ + "img/DINERS_60x36.df65ac9b.jpg";